import { Box, Grid, Text, TextInput, Select } from "grommet";
import { View } from 'react-native';
import { FrostedGlassBox, GapBox } from "../components";
import { ACTION_COLOURS } from '../constants';
import { MetricsSection } from "./MetricsSection";
import { PoolRegistrationSection } from "./PoolRegistrationSection"
import './InfoSection.css';
import React from 'react';



const InfoSection = ({
    id, 
    isMobile, 
    swimmingPoolData, 
    propertyTypeSelected, 
    reportData, 
    dealAcceptance, 
    styles, 
    panel,
    updatePanel,
    mappedData 
    }) => {
    const panelValues = panel.values || {};
    
    // Compute values from panel data (single source of truth)
    const bedrooms = panelValues.bedrooms || reportData?.property_summary?.bedrooms || null;
    const bathrooms = panelValues.bathrooms || reportData?.property_summary?.bathrooms || null;
    const carparks = panelValues.carparks || reportData?.property_summary?.carparks || null;
    const landArea = panelValues.land_area || reportData?.property_summary?.land_area || null;
    const floorArea = panelValues.floor_area || reportData?.property_summary?.floor_area || null;
    const rank = panelValues.tc_rank || '1RM';
    const emv = panelValues.market_value || null;
    const lvr = panelValues.lvr || null;
    const loanAmount = panelValues.loan_amount || null;
    const propertyUsage = panelValues.property_usage || null;
    const maxLVR = panelValues.max_lvr || reportData?.max_lvr || null;


    const [lvrFocused, setLvrFocused] = React.useState(false);
    const [lvrEditValue, setLvrEditValue] = React.useState('');
  
    // Direct update function - no local state to sync
    const updatePanelValue = (key, value) => {
        updatePanel(id, { [key]: value });
    };

    return (<>
        <FrostedGlassBox>
            <div class="container">
                <Box margin={{ top: '1rem', left: '1.5rem', bottom: '1rem' }}>
                    <Grid columns={{ count: isMobile ? 2 : 4, size: 'auto' }} gap="small">
                        <View className={'field-view'}>
                            <Box margin={{ top: '0' }}>
                                <Text flex='shrink' margin={{ vertical: 'auto' }} size="large">
                                    {`Property Type`}
                                </Text>
                                <Text flex='shrink' margin={{ vertical: 'auto' }} size="medium">
                                    {`${propertyTypeSelected}`}
                                </Text>
                            </Box>
                        </View>
                        <View className={'field-view'}>
                            <Box margin={{ top: '0rem' }}>
                                <Text flex='shrink' margin={{ vertical: 'auto' }} size="large">
                                    {`Land Titling`}
                                </Text>
                                <Text flex='shrink' margin={{ vertical: 'auto' }} style={{ whiteSpace: "pre-line" }} size="medium">
                                    {reportData?.land_titling ? reportData?.land_titling === 'Multiple Dwellings on One Title' ? `Multiple Dwellings ${"\n"}on One Title` : reportData?.land_titling : '-'}
                                </Text>
                            </Box>
                        </View>
                        <View className={'field-view'}>
                            <Box margin={{ top: '0rem' }}>
                                <Text flex='shrink' margin={{ vertical: 'auto' }} size="large">
                                    {`Max LVR`}
                                </Text>
                                <Text margin={'0 1rem 0 0rem'} size="medium">
                                    {maxLVR ? `${Math.floor(maxLVR * 100).toFixed(0)}%` : 'N/A'}
                                </Text>
                            </Box>
                        </View>
                        <View className={'field-view'}>
                            <Box margin={{ top: '0rem' }}>
                                <Text flex='shrink' margin={{ vertical: 'auto' }} size="large">
                                    {`Acceptance`}
                                </Text>
                                <Text margin={'0 1rem 0 0rem'} size="medium" style={{ color: ACTION_COLOURS[dealAcceptance] }}>
                                    {dealAcceptance}
                                </Text>
                            </Box>
                        </View>
                    </Grid>
                    <Grid columns={{ count: isMobile ? 1 : 2, size: 'auto' }} gap="small" >
                        <Grid columns={{ count: 2, size: 'auto' }} gap="small" height={{ min: '22rem' }} margin={{ top: '1rem' }}>
                            <Box margin={{ top: '1rem' }}>
                                <Text flex='shrink' margin={{ vertical: 'auto' }} size="large">
                                    {`Layout`}
                                </Text>
                                <View flex='shrink' align="start" style={[styles.container, {
                                    // Try setting `flexDirection` to `"row"`.
                                    flexDirection: 'column',
                                },
                                ]}>
                                    <View className={'field-view'}>
                                        <Box className={'field-box'}>
                                            <Text flex='shrink' margin={{ vertical: 'auto' }} size="xsmall">
                                                Bedrooms
                                            </Text>
                                            <TextInput
                                                flex='shrink'
                                                margin={{ bottom: '1rem' }}
                                                className={'field-input'}
                                                value={bedrooms === null || bedrooms === undefined ? '' : `${bedrooms}`}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow empty input
                                                    if (value === '') {
                                                        updatePanelValue('bedrooms', null);
                                                    }
                                                    // Only allow integer values
                                                    else if (/^\d+$/.test(value)) {
                                                        updatePanelValue('bedrooms', parseInt(value, 10));
                                                    }
                                                    // If non-integer input, don't update state
                                                }}
                                            />
                                        </Box>
                                    </View>
                                    <View className={'field-view'}>
                                        <Box className={'field-box'}>
                                            <Text flex='shrink' margin={{ vertical: 'auto' }} size="xsmall">
                                                Bathrooms
                                            </Text>
                                            <TextInput
                                                flex='shrink'
                                                margin={{ bottom: '1rem' }}
                                                className={'field-input'}
                                                value={bathrooms === null || bathrooms === undefined ? '' : `${bathrooms}`}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow empty input
                                                    if (value === '') {
                                                        updatePanelValue('bathrooms', null);
                                                    }
                                                    // Only allow integer values
                                                    else if (/^\d+$/.test(value)) {
                                                        updatePanelValue('bathrooms', parseInt(value, 10));
                                                    }
                                                    // If non-integer input, don't update state
                                                }}
                                            />
                                        </Box>
                                    </View>

                                    <View className={'field-view'}>
                                        <Box className={'field-box'}>
                                            <Text flex='shrink' margin={{ vertical: 'auto' }} size="xsmall">
                                                Carparks
                                            </Text>
                                            <TextInput
                                                flex='shrink'
                                                margin={{ bottom: '1rem' }}
                                                className={'field-input'}
                                                value={carparks === null || carparks === undefined ? '' : `${carparks}`}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow empty input
                                                    if (value === '') {
                                                        updatePanelValue('carparks', null);
                                                    }
                                                    // Only allow integer values
                                                    else if (/^\d+$/.test(value)) {
                                                        updatePanelValue('carparks', parseInt(value, 10));
                                                    }
                                                    // If non-integer input, don't update state
                                                }}
                                            />
                                        </Box>
                                    </View>

                                    <View className={'field-view'}>
                                        <Box className={'field-box'}>
                                            <Text flex='shrink' margin={{ vertical: 'auto' }} size="xsmall">
                                                Land Area (㎡)
                                            </Text>
                                            <TextInput
                                                flex='shrink'
                                                margin={{ bottom: '1rem' }}
                                                className={'field-input'}
                                                value={landArea === null || landArea === undefined ? '' : `${landArea}`}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow empty input
                                                    if (value === '') {
                                                        updatePanelValue('land_area', null);
                                                    }
                                                    // Allow decimal values for area
                                                    else if (/^\d*\.?\d*$/.test(value)) {
                                                        updatePanelValue('land_area', value);
                                                    }
                                                    // If invalid input, don't update state
                                                }}
                                            />
                                        </Box>
                                    </View>

                                    <View className={'field-view'}>
                                        <Box className={'field-box'}>
                                            <Text flex='shrink' margin={{ vertical: 'auto' }} size="xsmall">
                                                Floor Area (㎡)
                                            </Text>
                                            <TextInput
                                                flex='shrink'
                                                margin={{ bottom: '1rem' }}
                                                className={'field-input'}
                                                value={floorArea === null || floorArea === undefined ? '' : `${floorArea}`}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow empty input
                                                    if (value === '') {
                                                        updatePanelValue('floor_area', null);
                                                    }
                                                    // Allow decimal values for area
                                                    else if (/^\d*\.?\d*$/.test(value)) {
                                                        updatePanelValue('floor_area', value);
                                                    }
                                                    // If invalid input, don't update state
                                                }}
                                            />
                                        </Box>
                                    </View>
                                </View>
                            </Box>
                            <Box margin={{ top: '1rem' }}>
                                <Text flex='shrink' margin={{ vertical: 'auto' }} size="large">
                                    {`Deal Details`}
                                </Text>
                                <View flex='shrink' align="start" style={[styles.container, { flexDirection: 'column' }]}>
                                    <View className={'field-view'}>
                                        <Box className={'field-box'} width={{ max: isMobile ? '94.5%' : '100%' }}>
                                            <Text flex='shrink' margin={{ vertical: 'auto' }} size="xsmall">
                                                Ranking Needed
                                                <Text color={'red'} size="xsmall">*</Text></Text>
                                            <Select margin={{ vertical: 'auto', right: isMobile ? '24px' : '3.55rem' }}
                                                className={'field-select'}
                                                options={['1RM', '2RM']}
                                                onChange={(e) => updatePanelValue('tc_rank', e.value)}
                                                value={`${rank ?? '1RM'}`} />
                                        </Box>
                                    </View>

                                    <View className={'field-view'}>
                                        <Box className={'field-box'}>
                                            <Text flex='shrink' margin={{ vertical: 'auto' }} size="xsmall">
                                                EMV<Text color={'red'} size="xsmall">*</Text>
                                            </Text>
                                            <TextInput
                                                min={150000}
                                                flex='shrink'
                                                margin={{ vertical: 'auto' }}
                                                className={'field-input'}
                                                onChange={(e) => {
                                                    // Remove all non-numeric characters (except digits)
                                                    const rawValue = e.target.value.replace(/[^\d]/g, '');

                                                    // Convert to integer or null if empty
                                                    const numericValue = rawValue ? parseInt(rawValue, 10) : null;

                                                    // Update EMV
                                                    updatePanelValue('market_value', numericValue);

                                                    // If LVR exists, update the loan amount
                                                    if (lvr && lvr > 0 && numericValue) {
                                                        updatePanelValue('loan_amount', Math.round(lvr * numericValue));
                                                    }
                                                }}
                                                // Format the value as currency when displaying
                                                value={emv === null || emv === undefined
                                                    ? ''
                                                    : `$${emv.toLocaleString('en-AU')}`}
                                            />
                                        </Box>
                                    </View>
                                    <View className={'field-view'}>
                                        <Box className={'field-box'}>
                                            <Text flex='shrink' margin={{ vertical: 'auto' }} size="xsmall">
                                                LVR<Text color={'red'} size="xsmall">*</Text>
                                            </Text>
                                            <TextInput
                                                flex='shrink'
                                                margin={{ vertical: 'auto' }}
                                                className={'field-input'}
                                                onChange={(e) => {
                                                    // Get the raw input
                                                    const inputValue = e.target.value;

                                                    // Remove any percentage symbols and non-numeric/non-decimal characters
                                                    let rawValue = inputValue.replace(/%/g, '').replace(/[^\d.]/g, '');

                                                    // Handle multiple decimal points
                                                    if ((rawValue.match(/\./g) || []).length > 1) {
                                                        const parts = rawValue.split('.');
                                                        rawValue = parts[0] + '.' + parts.slice(1).join('');
                                                    }

                                                    // Save the raw edit value to display exactly what the user types
                                                    setLvrEditValue(rawValue);

                                                    // Process the value
                                                    if (rawValue === '' || rawValue === '.') {
                                                        updatePanelValue('lvr', null);
                                                    } else {
                                                        // Fix the floating point precision issue by using string operations
                                                        // instead of directly converting to float
                                                        let percentValue;
                                                        try {
                                                            percentValue = parseFloat(rawValue);
                                                        } catch (e) {
                                                            percentValue = NaN;
                                                        }

                                                        if (!isNaN(percentValue)) {
                                                            const clampedPercent = Math.min(Math.max(percentValue, 0), 100);

                                                            // Store the raw decimal value with string conversion to preserve precision
                                                            // For example, 50.5555 / 100 = 0.505555 exactly
                                                            const decimalString = (clampedPercent / 100).toString();
                                                            const decimalValue = parseFloat(decimalString);

                                                            updatePanelValue('lvr', decimalValue);

                                                            // Update loan amount based on EMV and LVR
                                                            if (!isNaN(emv) && emv > 0) {
                                                                updatePanelValue('loan_amount', Math.floor(decimalValue * emv));
                                                            }
                                                        }
                                                    }
                                                }}
                                                onFocus={() => {
                                                    setLvrFocused(true);
                                                    // When focusing, set the edit value to the current percentage value
                                                    // Use exact string conversion to avoid floating point issues
                                                    if (lvr !== null && lvr !== undefined) {
                                                        // Format the edit value to match exactly what would be displayed
                                                        const percentValue = lvr * 100;
                                                        // Preserve decimal places from original input if available
                                                        const existingDecimalPlaces = lvrEditValue.includes('.') ?
                                                            lvrEditValue.split('.')[1]?.length : 2;

                                                        if (existingDecimalPlaces && existingDecimalPlaces > 0) {
                                                            setLvrEditValue(percentValue.toFixed(existingDecimalPlaces));
                                                        } else {
                                                            setLvrEditValue(percentValue.toString());
                                                        }
                                                    } else {
                                                        setLvrEditValue('');
                                                    }
                                                }}
                                                onBlur={() => {
                                                    setLvrFocused(false);
                                                    // When blurring, if a valid number is present, format it to 2 decimal places
                                                    if (lvrEditValue !== '' && lvrEditValue !== '.') {
                                                        const value = parseFloat(lvrEditValue);
                                                        if (!isNaN(value)) {
                                                            // We don't update lvrEditValue here to preserve original precision
                                                        }
                                                    }
                                                }}
                                                // Use the appropriate display value based on focus state
                                                value={lvrFocused
                                                    ? lvrEditValue  // Show exactly what the user types when focused
                                                    : lvr === null || lvr === undefined
                                                        ? ''
                                                        : `${(lvr * 100).toFixed(2)}%`  // Format when not focused
                                                }
                                            />
                                        </Box>
                                    </View>
                                    <View className={'field-view'}>
                                        <Box className={'field-box'}>
                                            <Text flex='shrink' margin={{ vertical: 'auto' }} size="xsmall">
                                                Loan Amount<Text color={'red'} size="xsmall">*</Text>
                                            </Text>
                                            <TextInput
                                                min={0}
                                                max={emv}
                                                flex='shrink'
                                                margin={{ vertical: 'auto' }}
                                                className={'field-input'}
                                                onChange={(e) => {
                                                    // Remove all non-numeric characters (except digits)
                                                    const rawValue = e.target.value.replace(/[^\d]/g, '');

                                                    // Convert to integer or null if empty
                                                    let numericValue = rawValue ? parseInt(rawValue, 10) : null;

                                                    // Validation checks
                                                    if (numericValue !== null) {
                                                        // Prevent negative values (though regex should already handle this)
                                                        if (numericValue < 0) {
                                                            numericValue = 0;
                                                        }

                                                        // Cap at EMV if exceeding it
                                                        if (emv !== null && numericValue > emv) {
                                                            numericValue = emv;
                                                        }
                                                    }

                                                    // Update state with validated numeric value
                                                    updatePanelValue('loan_amount', numericValue);

                                                    // Calculate LVR if both values exist
                                                    if (numericValue && emv && emv > 0) {
                                                        // Store the exact float value in state
                                                        const lvrValue = numericValue / emv;
                                                        updatePanelValue('lvr', lvrValue);
                                                    }
                                                }}
                                                // Format the value as currency when displaying
                                                value={loanAmount === null || loanAmount === undefined
                                                    ? ''
                                                    : `$${loanAmount.toLocaleString('en-AU')}`}
                                            />
                                        </Box>
                                    </View>
                                    <View className={'field-view'}>
                                        <Box className={'field-box'} width={{ max: isMobile ? '94.5%' : '100%' }}>
                                            <Text flex='shrink' margin={{ vertical: 'auto' }} size="xsmall">
                                                Property Usage<Text color={'red'} size="xsmall">*</Text>
                                            </Text>
                                            <Select
                                                margin={{ vertical: 'auto', right: isMobile ? '24px' : '3.55rem' }}
                                                className={'field-select'}
                                                options={['--', 'O/O', 'I/V']}
                                                onChange={(e) => updatePanelValue('property_usage', e.value)}
                                                value={`${propertyUsage ?? '--'}`} />
                                        </Box>
                                    </View>

                                </View>
                            </Box>
                        </Grid>
                        <Box margin={{ top: isMobile ? '0rem' : '2rem', right: isMobile ? '0rem' : '1.5rem', left: isMobile ? '-0.75rem' : '0rem' }}>
                            <MetricsSection mappedData={mappedData} />
                            <GapBox />
                            <PoolRegistrationSection swimmingPoolData={swimmingPoolData} />
                        </Box>
                    </Grid>
                </Box>
            </div>
        </FrostedGlassBox>
    </>
    );
};

export { InfoSection }